import React from "react";
import ReactPaginate from "react-paginate";

const Paginate = (props) => {
  return (
    <ReactPaginate
      previousLabel={"قبلی"}
      nextLabel={"بعدی"}
      breakLabel={"..."}
      breakClassName={"break-me"}
      pageCount={props.totalPage}
      marginPagesDisplayed={2}
      pageRangeDisplayed={3}
      onPageChange={(data) => props.setPage(data.selected + 1)}
      containerClassName={"pagination"}
      activeClassName={"active"}
    />
  );
};

export default Paginate;
